export default __webpack_public_path__ + "assets/logo_della8_article-65e3c158.svg";